import { render, staticRenderFns } from "./pricesTable.vue?vue&type=template&id=0446f85c&scoped=true&"
import script from "./pricesTable.vue?vue&type=script&lang=js&"
export * from "./pricesTable.vue?vue&type=script&lang=js&"
import style0 from "./pricesTable.scss?vue&type=style&index=0&id=0446f85c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446f85c",
  null
  
)

export default component.exports